import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Shell } from "@/components/Shell";
import { setPin } from "@/lib/pin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SettingsPage() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const valid = current.trim() && next.trim().length >= 4 && !/\s/.test(next) && next === confirm;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) return setError("I due nuovi PIN non coincidono");
    setBusy(true);
    try {
      const res = await fetch(`${API}/impostazioni/pin`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", "X-Access-Code": current.trim() },
        body: JSON.stringify({ nuovo_pin: next.trim() }),
      });
      if (res.status === 401) throw new Error("Il PIN attuale non è corretto");
      if (res.status === 429) throw new Error("Troppi tentativi: riprova tra qualche minuto");
      if (res.status === 422) throw new Error("Il nuovo PIN deve avere da 4 a 32 caratteri, senza spazi");
      if (!res.ok) throw new Error("Server non raggiungibile");
      setPin(next.trim());
      toast.success("PIN aggiornato: usa il nuovo codice su tutti i tablet");
      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Shell header={<button className="btn btn-ghost !min-h-[44px] text-sm" onClick={() => navigate("/")} data-testid="settings-back-btn"><ArrowLeft size={16} /> Elenco</button>}>
      <div className="fade-up">
        <div className="flex items-center gap-3"><KeyRound className="text-[#2D4030]" size={24} /><p className="eyebrow">Impostazioni</p></div>
        <h1 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-[#2C221E] mt-2">Cambia il PIN</h1>
        <p className="text-[#5C4D46] mt-3 max-w-xl">Il PIN protegge le funzioni AI e l'invio email. Dopo il cambio, gli altri tablet chiederanno il nuovo codice al primo utilizzo.</p>

        <form onSubmit={submit} className="card p-6 sm:p-8 mt-8 max-w-md grid gap-5" data-testid="pin-change-form">
          <label className="grid gap-2">
            <span className="text-sm font-semibold text-[#2C221E]">PIN attuale</span>
            <input type="password" inputMode="numeric" autoComplete="current-password" className="field text-xl tracking-[0.3em]" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="pin-current-input" />
          </label>
          <label className="grid gap-2">
            <span className="text-sm font-semibold text-[#2C221E]">Nuovo PIN <span className="font-normal text-[#7A6B63]">(almeno 4 caratteri, senza spazi)</span></span>
            <input type="password" inputMode="numeric" autoComplete="new-password" className="field text-xl tracking-[0.3em]" value={next} onChange={(e) => setNext(e.target.value)} data-testid="pin-new-input" />
          </label>
          <label className="grid gap-2">
            <span className="text-sm font-semibold text-[#2C221E]">Ripeti il nuovo PIN</span>
            <input type="password" inputMode="numeric" autoComplete="new-password" className="field text-xl tracking-[0.3em]" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="pin-confirm-input" />
          </label>
          {error && <p className="text-sm text-[#A83232]" data-testid="pin-change-error">{error}</p>}
          <button type="submit" className="btn btn-primary w-full" disabled={!valid || busy} data-testid="pin-change-submit-btn">{busy ? "Salvataggio…" : "Salva il nuovo PIN"}</button>
        </form>
      </div>
    </Shell>
  );
}
